import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import useDataAttributesProp from '../../utils/hooks/use-data-attributes-prop/use-data-attributes-prop.js';
import { StyledCrate } from './crate.style.js';
import { useMapComponentPropsToStyledProps } from './crate.utils.js';

const Crate = props => {
    const { as = 'div', children, className, dataAttributes } = props, rest = __rest(props, ["as", "children", "className", "dataAttributes"]);
    const htmlDataAttributes = useDataAttributesProp(dataAttributes || {});
    const styledProps = useMapComponentPropsToStyledProps(rest);
    return (jsx(StyledCrate, Object.assign({ as: as, className: className }, htmlDataAttributes, styledProps, { children: children }), void 0));
};

export { Crate };
